import React, { useState } from 'react';
import '../styles/Products.scss';
import { useNavigate } from 'react-router-dom';
const UPI = `${process.env.REACT_APP_S3_URL}upipayLogo.svg`;
const IMPS = `${process.env.REACT_APP_S3_URL}impsLogo.svg`;
const BharatPay = `${process.env.REACT_APP_S3_URL}BharatPayLogo.svg`;
const AEPS = `${process.env.REACT_APP_S3_URL}aepsLogo.svg`;
const RightArrow = `${process.env.REACT_APP_S3_URL}rightSlantblack.svg`;
const products = [
    { id: 1, name: 'Unified Payments Interface',description: '#SeamlessTransactions', logo: UPI },
    { id: 2, name: 'Immediate Payment Service',description: '#RealTimePayments', logo: IMPS },
    { id: 3, name: 'Bharat Bill Payment System',description: '#SimplifyBillManagement', logo: BharatPay },
    { id: 4, name: 'Aadhaar Enabled Payment System',description: '#RemoteAEPSInclusion', logo: AEPS }
];

const Products: React.FC = () => {
    
    const navigate = useNavigate();
    const [hoveredCardId, setHoveredCardId] = useState<number | null>(null);

    // Handlers to update hover state for each card
    const handleMouseEnter = (id: number) => {
        setHoveredCardId(id);
    };

    const handleMouseLeave = () => {
        setHoveredCardId(null);
    };

    const redirectTo = (productId: any) =>  {
        switch(productId){
            case 1: 
                navigate('/products/upi');
                break;
            case 2: 
                navigate('/products/imps');
                break;
            case 3: 
                navigate('/products/bbps');
                break;
            case 4: 
                navigate('/products/aeps');
                break;
            default:
                navigate('/products/upi');
                break;
        }
    }

    return (
        <section className="products">
            <h2>
                <strong
                style={{
                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text', // For Firefox
                    color: 'transparent',
                  }}
                >
                    Products&nbsp;
                </strong>
            We Offer
            </h2>
            <span>
            Our NPCI certified Payment Switches for Banks & FinTechs
            </span>
            <div className="products-grid">
                {products.map(product => (
                    <div onClick={() => redirectTo(product.id)} key={product.id} className="product-card"
                    onMouseEnter={() => handleMouseEnter(product.id)}
                    onMouseLeave={handleMouseLeave}
                    >
                        <div className={`product-image ${hoveredCardId === product.id ? 'product-image-highlight' : ''}`}>
                            <img src={product.logo} alt={product.name} />
                        </div>
                        <p>{product.name}</p>
                        <span>{product?.description}</span>

                        {hoveredCardId === product.id && (
                            <img
                            src={RightArrow}
                            alt="Hovered"
                            style={{
                                position: 'absolute',
                                bottom: '-8px',
                                right: '-8px'
                            }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Products;
